import { render, staticRenderFns } from "./DistintaBase.vue?vue&type=template&id=f1e62582&scoped=true&"
import script from "./DistintaBase.vue?vue&type=script&lang=js&"
export * from "./DistintaBase.vue?vue&type=script&lang=js&"
import style0 from "./DistintaBase.vue?vue&type=style&index=0&id=f1e62582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e62582",
  null
  
)

export default component.exports